"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapProductBoxPropsFromStaticApi = void 0;
var _internal = require("./internal");
const mapProductBoxPropsFromStaticApi = params => (0, _internal.mapProductBoxProps)(params);
exports.mapProductBoxPropsFromStaticApi = mapProductBoxPropsFromStaticApi;
//# sourceMappingURL=mapProductBoxPropsFromStaticApi.js.map